import styled from "styled-components";
import { Radio } from "semantic-ui-react";

export const Container = styled.div`
    padding: 12px 16px;
`;

export const SectionTitle = styled.div`
    font-size: 12px;
    gap: 8px;
    color: #6a7282;
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const PrivacyBadge = styled.div`
    padding: 4px 8px;
    background: #f3f4f6;
    border-radius: 8px;
    color: #4a5565;
    font-size: 12px;
`;

export const Toggle = styled(Radio)`
    &.ui.toggle.checkbox input:checked ~ label:before {
        background: #700ac1 !important;
    }

    &.ui.toggle.checkbox input:focus:checked ~ label:before {
        background: #700ac1 !important;
    }
`;
